import { IPatient } from './patient';
import { IContact } from './contact';
import { TriagedApp } from '../contexts/triage/types';

export interface ISchedule {
  id?: number;
  method?: string;
  start: Date;
  startDate?: Date; // legacy
  end?: Date;
  endDate?: Date; // legacy
  tz: string;
  times?: string[];
  days?: number[];
  mode?: string;
  step?: number;
  isFixed?: boolean;
  language?: string;
  modules?: any;
  // Control states
  task?: string;
  pastTasks?: string[];
  isCanceled: boolean;
  canceledAt?: Date;
  // Associations
  patientId: number;
  contactId: number;
  // Attachments
  patient?: IPatient;
  contact?: IContact;
  // Timestamps
  createdAt?: Date;
  updatedAt?: Date;
}

export const IsTriageAppEnded = (appEntry: TriagedApp): boolean => {
  if (!appEntry.endedSchedule) {
    return false;
  }
  if (!appEntry.schedule) {
    return true;
  }
  /**
   * If the schedule and endedSchedule have the same ID,
   * then the app has ended
   */
  if (appEntry.schedule.id === appEntry.endedSchedule.id) {
    return true;
  }
  /**
   * If the program waiver has been revoked,
   * then the app has ended
   */
  if (appEntry.waiver?.isRevoked) {
    return true;
  }
  return false;
};
